import { useQuery } from '@tanstack/react-query'
import type { Profile } from '@/types/db'
import { getSupabase } from '@/lib/supabase'
import { useAuth } from '@/lib/auth'

export function useProfile() {
  const { user } = useAuth()

  return useQuery({
    queryKey: ['profile', user?.id],
    enabled: Boolean(user?.id),
    queryFn: async (): Promise<Profile | null> => {
      if (!user) return null
      const { data, error } = await getSupabase()
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .maybeSingle()
      if (error) throw error
      return data as Profile | null
    },
    // Profile có thể đổi runtime (admin update full_name, role legacy hoặc
    // toggle is_active). 30s đủ để cân bằng giữa fresh và RPC count.
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  })
}
